import DeleteBin from '@assets/icons/delete-bin.svg'
import { Icon } from './Icon'

export const DeleteBinIcon = Icon(DeleteBin)
